module.exports = __webpack_public_path__ + "aee0310be2d4fa9e4ccc67c62ef167af.png";